import axios from 'axios';
import { RrSettingDataType } from '../../../common/dist/common';
import { toData } from './base';

export function getRr() {
  return toData<RrSettingDataType>(axios.get('/api/setting/rr'));
}

export function putRr(data: Partial<RrSettingDataType>) {
  return toData<{}>(axios.put('/api/setting/rr', data));
}

export default {
  getRr,
};
